// Import: Packages
import React from 'react';
import styled from 'styled-components/macro';
import { Col, Div } from '../../../../grid';
import { Paragraph } from '../../../../typography';
import KlapbarUdsolgt from '../../../../UdsolgtTexts/KlapbarUdsolgt';
import PriceText from '../../../Item/list-views/PriceText';
import RenderButtons from './RenderButtons';
import RenderIconBoxes from './RenderIconBoxes';
import AnlaegUdsolgt from '../../../../UdsolgtTexts/AnlaegUdsolgt';

const StyledCol = styled(Col)`
  padding: 15px;

  @media (max-width: 991px) {
    padding: 5px 15px;
  }
`;

function RenderProductTypePack(props) {
  const {
    smallScreen,
    countPrColli,
    productTypePack,
    betingerFustager,
    dobbeltAnlaeg,
    betingerFustagerUdstyr,
    udsolgtKlapbar,
    udsolgtAnlaeg,
    IconBoxes,
    price,
    isLeje,
    replaceStkWithPackageNoun,
    simpleAmountDescriptor,
    extendedAmountDescriptor,
    packageNoun,
    amount,
    actions,
    inStock,
    inStockText,
    notice,
    description,
  } = props;

  if (!productTypePack) {
    return null;
  }

  return (
    <React.Fragment>
      {description && (
        <StyledCol xs={12}>
          <Div paddingTop="10px">{description()}</Div>
        </StyledCol>
      )}
      <StyledCol xs={12}>
        <Paragraph fontSize="18px" bold marginBottom={betingerFustager && '0px'}>
          <PriceText
            price={price}
            isLeje={isLeje}
            replaceStkWithPackageNoun={replaceStkWithPackageNoun}
            simpleAmountDescriptor={simpleAmountDescriptor}
            extendedAmountDescriptor={extendedAmountDescriptor}
            packageNoun={packageNoun}
            countPrColli={countPrColli}
            momsIndication
          />
        </Paragraph>
        {betingerFustager && !dobbeltAnlaeg && (
        <Paragraph fontSize="12px" marginBottom="0">
          Lejeprisen betinger køb af fustager
        </Paragraph>
        )}
        {betingerFustager && dobbeltAnlaeg && (
        <Paragraph fontSize="12px" marginBottom="0">
          Lejeprisen betinger køb af fustager til begge anlæg
        </Paragraph>
        )}
        {betingerFustagerUdstyr && (
        <Paragraph fontSize="12px" marginBottom="0">
          Lejeprisen betinger køb af fustager, samt leje af udstyr
        </Paragraph>
        )}
      </StyledCol>
      {udsolgtAnlaeg && (
      <StyledCol xs={12}>
        <AnlaegUdsolgt />
      </StyledCol>
      )}
      {udsolgtKlapbar && (
      <StyledCol xs={12}>
        <KlapbarUdsolgt />
      </StyledCol>
      )}
      <RenderButtons smallScreen={smallScreen} amount={amount} actions={actions} inStock={inStock} inStockText={inStockText} notice={notice} />
      {!smallScreen && <RenderIconBoxes productTypePack={productTypePack} IconBoxes={IconBoxes} />}
    </React.Fragment>
  );
}

export default RenderProductTypePack;
